import { some } from 'lodash';
import moment from 'moment';

import { APP_ID } from '@src/emp-3.0/components/Sankey/utils/constants';
import { IEventFilter, ISankeyDimension } from '@src/emp-3.0/types';

export const formatFilters = (
  arr: IEventFilter[][],
  sankeyDimensionList: ISankeyDimension[] = [],
) => {
  let hasAppId = false;
  const filteredArray = arr.filter((condition) => condition.some((obj) => obj.op === 'eq'));
  const groupedByField = {};

  const canFilterDimension = sankeyDimensionList.filter((dimension) => dimension.can_filter === 1);

  filteredArray.forEach((condition) => {
    condition.forEach((obj, i) => {
      const isSankeyDimension = some(canFilterDimension, { dimension_name: obj.field });
      if (obj.op === 'eq' && isSankeyDimension) {
        const value = obj.value;
        if (obj.field === APP_ID) {
          hasAppId = true;
        }
        if (i === 0 && !groupedByField[obj.field]) {
          groupedByField[obj.field] = [
            {
              field: obj.field,
              op: 'eq',
              value: [value],
            },
          ];
        } else {
          // APP_ID only keep one value
          if (obj.field !== APP_ID) {
            groupedByField[obj.field]?.push({
              field: obj.field,
              op: 'eq',
              value: [value],
            });
          }
        }
      }
    });
  });
  const res = Object.values(groupedByField) as IEventFilter[][];
  if (!hasAppId) {
    res.push([{ field: APP_ID, op: 'eq', value: [] }]);
  }
  return res;
};

export const formatInterval = (interval, calenderBoundry) => {
  let intervalFormat = `${moment().subtract(24, 'hour').format()}/${moment().format()}`;

  // set 24 hours from calenderBoundry endTime
  const intervalStart = moment(calenderBoundry.end_time).subtract(24, 'hour').format();
  const intervalEnd = moment(calenderBoundry.end_time).format();
  intervalFormat = `${intervalStart}/${intervalEnd}`;

  if (interval) {
    if (typeof interval === 'string') {
      return interval;
    }
    const from = moment(interval.from);
    const to = moment(interval.to);
    // if (to.diff(from, 'hour') > 24) {
    //   from = to.clone().subtract(24, 'hour');
    // }
    // if interval is outside of calenderBoundry break if from here
    if (from.isBefore(calenderBoundry.start_time) || to.isAfter(calenderBoundry.end_time)) {
      return intervalFormat;
    }
    intervalFormat = `${from.format()}/${to.format()}`;
  }
  return intervalFormat;
};
